import { State } from '@/store/state'
import { parseISO } from 'date-fns'
import { ActionContext, ActionTree } from 'vuex'
import { Mutations, MutationTypes } from './mutations'


type AugmentedActionContext = {
	commit<K extends keyof Mutations>(
		key: K,
		payload: Parameters<Mutations[K]>[1]
	): ReturnType<Mutations[K]>
} & Omit<ActionContext<State, State>, 'commit'>

export enum ActionTypes {
	GET_CB_DATA = 'GET_CB_DATA',
	GET_TS_DATA = 'GET_TS_DATA',
	GET_GEOREF_DATA = 'GET_GEOREF_DATA',
	GET_DISASTER_DATA = 'GET_DISASTER_DATA'
}

export interface Actions {
	[ActionTypes.GET_CB_DATA]({ commit }: AugmentedActionContext): void
	[ActionTypes.GET_TS_DATA]({ commit }: AugmentedActionContext): void
	[ActionTypes.GET_GEOREF_DATA]({ commit }: AugmentedActionContext): void
	[ActionTypes.GET_DISASTER_DATA]({ commit }: AugmentedActionContext): void
}

export const actions: ActionTree<State, State> & Actions = {
	async [ActionTypes.GET_CB_DATA]({ commit, state }) {
		commit(MutationTypes.SET_LOADING, undefined)

		const path =
			process.env.NODE_ENV === 'production'
				? '/vp-cloud-band-explorer/data/cloud-blobs.geojson'
				: '/data/cloud-blobs.geojson'
		const rawData = await fetch(path)
		const json = await rawData.json()
		commit(MutationTypes.SET_CB_DATA, json)

		commit(MutationTypes.SET_FINISHED_LOADING, undefined)
	},
	async [ActionTypes.GET_TS_DATA]({ commit, state }) {
		commit(MutationTypes.SET_LOADING, undefined)

		const path =
			process.env.NODE_ENV === 'production'
				? '/vp-cloud-band-explorer/data/rain_ts_st.json'
				: '/data/rain_ts_st.json'
		const rawData = await fetch(path)
		const json = await rawData.json()
		commit(MutationTypes.SET_TS_DATA, json)

		commit(MutationTypes.SET_FINISHED_LOADING, undefined)
	},
	async [ActionTypes.GET_GEOREF_DATA]({ commit, state }) {
		commit(MutationTypes.SET_LOADING, undefined)

		const path =
			process.env.NODE_ENV === 'production'
				? '/vp-cloud-band-explorer/data/municipalities_georef.json'
				: '/data/municipalities_georef.json'
		const rawData = await fetch(path)
		const json = await rawData.json()
		commit(MutationTypes.SET_GEOREF_DATA, json)

		commit(MutationTypes.SET_FINISHED_LOADING, undefined)
	},
	async [ActionTypes.GET_DISASTER_DATA]({ commit, state }) {
		commit(MutationTypes.SET_LOADING, undefined)

		const path =
			process.env.NODE_ENV === 'production'
				? '/vp-cloud-band-explorer/data/disasters.json'
				: '/data/disasters.json'
		const rawData = await fetch(path)
		const json = await rawData.json()

		const highlightsPath =
			process.env.NODE_ENV === 'production'
				? '/vp-cloud-band-explorer/data/disaster_highlights	.json'
				: '/data/disaster_highlights	.json'
		const highlightData = await fetch(highlightsPath)
		const highlights = await highlightData.json()

		highlights.forEach((highlight: any) => {
			json.forEach((disaster: any) => {
				if(highlight.date === disaster.date && highlight.mCode === disaster.mCode) {
					disaster.major = {
						...highlight
					}
				}
			})
		})

		commit(
			MutationTypes.SET_DISASTER_DATA,
			json.map((d: any) => {
				const ret = { ...d }
				ret.date = parseISO(`${d.date}T00:00:00.000`)
				return ret
			})
		)

		commit(MutationTypes.SET_FINISHED_LOADING, undefined)
	}
}
